// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L7b5","colMin":"styles_colMin__l8gDP"};